import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;
console.log(baseURL, "baseurllll")


export const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true,
});

export const fetchApi = async ({
  body,
  header,
  method,
  url,
  baseUrl = baseURL,
}) => {
  const data = JSON.stringify(body);
  const headers = header;
  const pathUrl = `${baseUrl}${url}`;

  try {
    const response = await fetch(pathUrl, {
      body: data,
      method,
      headers,
    });

    const result = await response.json();

    return {
      data: result,
      hasError: !response.ok,
      status: response.status,
      statusText: response.statusText,
    };
  } catch (error) {
    return {
      data: error,
      hasError: true,
      status: error.status || 500,
      statusText: error.message || 'Internal Server Error',
    };
  }
};
